<template>
  <div v-show="show">
    <header class="header-main_v2">
      <nav class="mobile-menu">
        <div class="menu_v2_contains">
          <div class="logo">
            <router-link to="/visitor" :class="['logo-header', getActiveTabClass('/visitor')]">
              <img :src="getTranslations.project_logo_img" alt="">
            </router-link>
          </div>
          <button data-menu="dropdown_lang" class="nav__toggle nav__toggle_lang"></button>
          <button data-menu="nav_dropdown_burgerMenu" :class="['nav__toggle nav__toggle_burgerMenu', isIos ? 'ui_desc_ios' : '']"><span></span></button>
          <div class="items">
            <nav class="main-nav">
              <ul v-if="!hideLangSelection" class="main-nav__lang" id="get_started_menu">
                <li class="dropdown">
                  <a> <div class="icon-globe"><img src="static/images/icon-globe.svg" alt=""></div></a>
                  <ul>
                    <li v-for="(value, key) in availableLocales" :key="key" style="cursor:pointer">
                      <a @click.prevent="changeLanguage(key)" :class="getActiveTabLocale(key)">{{ value }} </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <input type="checkbox" id="checkbox" class="mobile-menu__checkbox">
        <label for="checkbox" class="mobile-menu__btn">
          <div class="mobile-menu__icon">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </label>
        <div class="mobile-menu__container">
          <ul class="mobile-menu__list">
            <li v-if="!hideLeaderboard" class="mobile-menu__item"> <!-- PRIZES & LEADERBOARDS -->
              <router-link to="/home/prizesAndLeaderBoards" :class="['mobile-menu__link', getActiveTabClass('/home/prizesAndLeaderBoards')]">
                {{ getTranslations.home_home_prizes_and_leaderboards }}
              </router-link>
            </li>
            <li v-if="!hideWinners" class="mobile-menu__item"> <!-- WINNERS -->
              <router-link to="/winners" :class="['mobile-menu__link', getActiveTabClass('/winners')]">
                {{ getTranslations.home_home_winners }}
              </router-link>
            </li>
            <li class="mobile-menu__item"> <!--HOW IT WORKS -->
              <router-link to="/howItWorks" :class="['mobile-menu__link', getActiveTabClass('/howItWorks')]">
                {{ getTranslations.home_home_how_it_works }}
              </router-link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <router-view></router-view>
    <footer class="footer-main">
      <div class="containers">
        <nav class="footer-nav">
          <ul class="footer-nav__list">
            <li>
              <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.visitor_t_and_c }}</a>
            </li>
            <li>
              <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_privacy_and_policy')" target="_blank">{{ getTranslations.visitor_visitor_privacy_policy }}</a>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
    <div class="black-overlay"></div>
    <simplify-registration v-if="showSimpleRegistrationModal"
                           @close="showSimpleRegistrationModal = false;">
    </simplify-registration>
    <sub-verify-wifi v-if="HE_ERROR_CODE"
                     @close="HE_ERROR_CODE = false;">
    </sub-verify-wifi>
    <operator-selection v-if="getSelectOperatorModalChoice()"
                        @close="toggleSelectOperatorModal(false);">
    </operator-selection>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import Vue from 'vue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import RegistrationFlowMixin from '@/common/mixins/flow';
import simplifyRegistration from '@/components/home/modals/SimplifyRegistration';
import subVerifyWifi from '@/components/home/modals/SubscriptionVerifyWifi';
import operatorSelection from '@/components/home/modals/OperatorSelectionModal';
import { handleLanguageDropdown, handleBurger, openCloseTab } from '../../common/jQuery';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'navigation-header',
  mixins: [IntegrationMixin, RegistrationFlowMixin],
  components: { simplifyRegistration, subVerifyWifi, operatorSelection },
  data() {
    return {
      isIos: false,
      operatorLogoForBrandedProject: '',
      currentTabPath: '',
      showSimpleRegistrationModal: false,
      show: true,
    };
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.hidePage()) vm.showPage(false);
      vm.getIntegration(to);
    });
  },
  created() {
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.currentTabPath = sessionStorage.getItem('visitorCurrentTabPath');
    this.operatorLogoForBrandedProject = this.isBrandedProject ? `static/skins/skin_${this.duelSkin.toString()}/images/logo-operator-footer.svg` : '';
  },
  mounted() {
    console.log(this.getDisplayedLocale);
    this.$nextTick(() => {
      handleLanguageDropdown();
      handleBurger();
    });
    openCloseTab();
  },
  beforeRouteUpdate(to, from, next) {
    // eslint-disable-next-line
    $(window).scrollTop(0);
    this.getIntegration(to);
    console.log(`from: ${from.path}`);
    console.log(`to: ${to.path}`);
    this.currentTabPath = to.path;
    sessionStorage.setItem('visitorCurrentTabPath', to.path);
    next();
  },
  methods: {
    ...mapActions('common', [
      'facebookSDKApi',
    ]),
    ...mapActions('profile', [
      'storeVisitorWinners',
      'storeAvailablePrizeTypes',
      'storeAvailablePrizeTypesPerGame',
    ]),
    ...mapActions('i18n', [
      'getTranslationsFile',
    ]),
    ...mapMutations('i18n', [
      'setLocale',
      'changeCSSFile',
    ]),
    ...mapMutations('common', [
      'setUserLanguage',
    ]),
    showPage(value) {
      this.show = value;
    },
    encryptUrlBuilder() {
      if (!this.hasWebRegister()) {
        this.showSimpleRegistrationModal = true;
      } else {
        this.registrationRedirect();
      }
    },
    getIntegration(to) {
      if (to.path === '/') this.checkForRegisterRedirect(to);
      else this.showPage(true);
    },
    checkForRegisterRedirect(to) {
      this.getIntegrationParametersCheck()(to);
    },
    toCreditsPage() {
      this.$router.push('/credits');
    },
    changeLanguage(newValue) {
      console.log(`New Language ${newValue}`);
      this.setUserLanguage(newValue);
      localStorage.setItem('locale', newValue);
      this.setLocale({ currentLocale: newValue });
      this.getTranslationsFile().then(() => {
        moment.locale(this.getLocale.toLowerCase());
        this.storeVisitorWinners(localStorage.getItem('locale')).then(() => {
          this.storeAvailablePrizeTypes(localStorage.getItem('locale')).then(() => {
            this.storeAvailablePrizeTypesPerGame(localStorage.getItem('locale'));
            this.facebookSDKApi().then(() => {
              this.changeCSSFile();
            });
          });
        });
      });
    },
    getActiveTabLocale(key) {
      return this.getLocale === key ? 'active' : '';
    },
    getActiveTabClass(path) {
      return this.currentTabPath === path ? 'active' : '';
    },

  },
  computed: {
    ...mapState('i18n', [
      'availableLocales',
    ]),
    ...mapState('common', [
      'hideLangSelection',
      'hidePrizePage',
      'hideWinners',
      'hideLeaderboard',
      'logoOnFooter',
      'multiOperatorInfo',
      'duelSkin',
      'isBrandedProject',
    ]),
    ...mapGetters('i18n', [
      'getLocale',
      'getDisplayedLocale',
      'getTranslationByOperator',
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Visitor.vue